import { useTranslation } from 'react-i18next';
import { LuTriangleAlert } from 'react-icons/lu';

export const NotificationRowError = () => {
    const { t } = useTranslation();
    return (
        <div className="flex items-center gap-3 py-4 text-sm text-alert-error" role="alert">
            <LuTriangleAlert className="size-5 shrink-0" />
            <span>{t('TOP_HEADER.NOTIFICATIONS.ERROR')}</span>
        </div>
    );
};
